
"use strict"; // jshint ignore:line

import {
	Math as THREEMath,
	Object3D,
	Euler,
	Vector3,
	Mesh,
	Texture,
	TextureLoader,
	PlaneGeometry,
	Group,
	MeshPhongMaterial,
	MeshBasicMaterial,
	GridHelper,
	SphereGeometry
} from '../../../src/js/three.module.js';

import { WallService } from '../services/WallsHandlerService.js';
 
import { getTextureLoader } from '../../utils/loaders/loader-manager.js';

var spherical360SetupService;

export default function Spherical360SetupService( $rootScope,  $compile,  $timeout,  wallsHandlerService,  userActionHistoryService ) {

	spherical360SetupService = $rootScope.spherical360SetupService = window.spherical360SetupService = this;

	var gridBox = this.gridBox = new Object3D();

	Group.call( this );

	this.getInstance = () => spherical360SetupService;

	this.enabled = false;

	this.setups = []
	
	this.attachedPlayerNeedsUpdate = false;
	this.setupPlayerAttachedTo     = null;

	userActionHistoryService.addActs({
		"spherical360Setups.enable": {},
		"spherical360Setups.disable": {},
		"spherical360Setups.attachPlayer": {},
		"spherical360Setups.detachPlater": {},
		"spherical360Setups.addSetup": {},
		"spherical360Setups.removeSetup": {}
	});
		
	$rootScope.$on( "spherical360SetupService.playerAttached", function( event, setup ) {
				
		setTimeout(function() {
			if (setup.texture instanceof Texture) {
				
				let large_image_url = setup.buildImageUrl( 'large' )

				if (setup.texture.image) {
					if (setup.texture.image.src == large_image_url) return;
				}

				/* new TextureLoader() */ getTextureLoader().load( large_image_url, function( texture ) {
					setup.setTexture( texture );
				});
			}
		});

		/*$timeout(function() {
			if (setup.image_uid) {
					getTextureLoader().load( "/i/" + setup.image_uid + "?size=1024x1024^", function( texture ) {
						setup.setTexture( texture );
					});
				}
			}
		});*/
	});

	this.update = function() {

		if (this.attachedPlayerNeedsUpdate) {

			this.attachedPlayerNeedsUpdate = false;

			var setup = this.setupPlayerAttachedTo;

			if (setup) {

				player.height = setup.height;
				player.setPos( setup.position );

				gridBox.position.copy( player.headPos );
			}
		}
	};


	var revertable_original_stuffs = {};

	this.enable = function() {
		
		if (this.enabled) return;

		try {
			decorateAddinationalWalls();

			decoratePlayer();

			decorateDOM();

			decorateHelpers();

			revertable_original_stuffs.__rootScope__on__onControlModeVisibilityChanged = $rootScope.$on( "onControlModeVisibilityChanged", function( event, visible ) {
				for (var uuid in wallsHandlerService.additional_walls) try {
					wallsHandlerService.additional_walls[ uuid ].mesh.material.opacity = visible ? 0.5 : 0;

					wallsHandlerService.additional_walls[ uuid ].wireframe.visible = visible;
				} catch (error) {
					console.error( error );
				}

				// gridBox.visible = visible && false;

			});

			$rootScope.$broadcast( "spherical360SetupServiceEnabled" );

			helpers.disabled = true;

			this.enabled = true;

		} catch (error) {

			console.error( error );

			this.disable();
		}

		function decorateAddinationalWalls() {

			/********
			 *
			 */
			revertable_original_stuffs.wallService__options__additional_wall_default_depth = wallsHandlerService.options.additional_wall_default_depth;

			wallsHandlerService.options.additional_wall_default_depth = 0.01;

			/********
			 *
			 */
			revertable_original_stuffs.WallService__WallProto__generateMaterial = WallService.WallProto.generateMaterial;

			WallService.WallProto.generateMaterial = function( material ) {

				material = angular.extend({ }, material || {}, {
					transparent: true,
					opacity: 0.5
				});

				return new MeshPhongMaterial( material );
			};

			for (var uuid in wallsHandlerService.additional_walls) try {

				var wall = wallsHandlerService.additional_walls[ uuid ];

				wall.material = wall.mesh.material = WallService.WallProto.generateMaterial( wall.mesh.material );

			} catch (error) { console.error( error ); }


			/*****/
/*
			revertable_original_stuffs.WallService__AdditionalWall = WallService.AdditionalWall;

			WallService.AdditionalWall = function( edgeA, edgeB, bottomY, height ) {
				revertable_original_stuffs.WallService__AdditionalWall.call( this, edgeA, edgeB, bottomY, height, 0.01 );
			}
			WallService.AdditionalWall.prototype = Object.create( revertable_original_stuffs.WallService__AdditionalWall.prototype );
*/
		}

		function decoratePlayer() {

			/********
			 *
			 */

			var parent, floor = player.floorObj;

			if (floor) {
				revertable_original_stuffs.player__floorObj = floor;
			
				parent = player.floorObj.parent;

				if (parent) {
					parent.remove( player.floorObj );
				}
			}

			floor = player.floorObj = new Mesh( new PlaneGeometry( 1, 1 ), new MeshBasicMaterial({
				color: 0xffffff,
				transparent: true,
				opacity: 0.25
			}));

			Object.defineProperty( floor, "visible", {
				set: function( visible ) {
					if (visible) {
						player.floorObj.material.opacity = 0.25;
					} else {
						player.floorObj.material.opacity = 0;
					}
						
					if (player.floorObj.grid) player.floorObj.grid.visible = visible;
				},
				get: function() {
					return true;
				}
			});

			floor.visible = false;

			floor.renderOrder = 1;
			
			floor.userData.type = "world";

			floor.rotation.x = -Math.PI / 2; // Asetetaan "katsomaan ylös", eli kameran alle lattian suuntaisesti

			floor.setSize = function( size ) {

				if (floor.grid) {
					floor.remove( floor.grid );
				}

				floor.size = size;

				floor.geometry = new PlaneGeometry( size, size );

				floor.grid = new GridHelper( size, size );
				floor.grid.rotation.x = floor.rotation.x;
				floor.grid.visible = false;

				floor.add( floor.grid );
			};

			floor.refresh = function(){
				if (window.gameService.opts.game.lockToGrid == "world") floor.position.set( 0, player.pos.y, 0 );
				else floor.position.copy( player.pos );
			};

			(parent || worldModel).add( floor );

			floor.setSize( 32 );
			floor.refresh();
		}

		function decorateDOM() {

			/********
			 *
			 */
			document.body.classList.add( "spherical360Setups-enabled" );

			/********
			 *
			 */
			var view_ctrl_btn_wrapper = $( "#artestUserBar .navbar-header ul.leftie-btn-wrapper" ), view_ctrl_btn;

			try {

				view_ctrl_btn = $( "li.spherical360Setups-selector", view_ctrl_btn_wrapper );

				if (!view_ctrl_btn[0]) {
					if ($User.logged) {
						var _li = $(
						`<li class="useleft spherical360Setups-selector" uib-dropdown>
							<a uib-dropdown-toggle>{{ 'Select 360 setup' | translate }} <b class="caret"></b></a>
							<ul uib-dropdown-menu>
								<li ng-repeat=" setup in spherical360SetupService.setups " ng-class="{ 'active': spherical360SetupService.setupPlayerAttachedTo == setup }">
									<a ng-click="spherical360SetupService.attachPlayer( setup )">{{ setup.name || setup.uuid }}</a>
								</li>
							</ul>
						</li>` );

						view_ctrl_btn_wrapper.prepend( _li );

						var scope = $rootScope.$new( true );
						
						scope.spherical360SetupService = spherical360SetupService;

						$compile( _li )( scope );
					}
				} else if (!$User.logged) {
					view_ctrl_btn.remove();
				}

			} catch (error) {

				console.error( error );

				view_ctrl_btn && view_ctrl_btn.remove();
			}
		}

		function decorateHelpers() {
			/********
			 *
			 */
			var size = 5;
			var size2 = 2 * size2;

			var sides = "xplus,xminus,yplus,yminus,zplus,zminus".split(",").reduce(function( sides, side ) {
				sides[side] = new GridHelper( size2, size2 );
				gridBox.add( sides[side] );
				return sides;
			}, { });

			sides.yminus.position.y -= size;
			sides.yplus.position.y  += size;

			sides.xminus.position.x -= size;
			sides.xplus.position.x  += size;

			sides.zminus.position.z -= size;
			sides.zplus.position.z  += size;


			sides.xminus.rotation.z = -Math.PI/2;
			sides.xplus.rotation.z  = Math.PI/2;

			sides.zminus.rotation.x = -Math.PI/2;
			sides.zplus.rotation.x  = Math.PI/2;	

			gridBox.visible = false;
			
			worldModel.add( gridBox );
		}
	};

	this.disable = function() {

		this.enabled = false;

		$rootScope.$broadcast( "spherical360SetupServiceDisabled" );

	};

	this.add = function( setup ) {

		if (angular.isString( setup )) {
			setup = new Spherical360Setup( setup, arguments[1] || { });
		}

		if (!(setup instanceof Spherical360Setup)) {
			throw new Error( "Invalid argument!" );
		}

		this.setups.push( setup );

		Object.defineProperty( this.setups, setup.uuid, {
			value: setup,
			enumerable: false,
		});

		setup.mesh.visible = false;

		Group.prototype.add.call( this, setup.mesh );
	};

	this.remove = function( setup ) {

		if (angular.isString( setup )) {
			setup = new Spherical360Setup( setup, arguments[1] || { });
		}

		if (!(setup instanceof Spherical360Setup)) {
			throw new Error( "Invalid argument!" );
		}

		var idx = this.setups.indexOf( setup );

		if (idx == -1) return;

		this.setups.splice( idx, 1 );

		delete this.setups[ setup.uuid ];

		Group.prototype.remove.call( this, setup.mesh );

		if (setup == this.setupPlayerAttachedTo) {
			this.detachPlayer();
		}
	};

	this.attachPlayer = function( setup ) {

		if (angular.isString( setup )) {
			setup = this.setups[ setup ];
		}

		if (!(setup instanceof Spherical360Setup)) {
			throw new Error( "Invalid argument!" );
		}
		
		this.enable();

		player.opts.disableGravity = true;
		player.$keyboardControlsDisabled = true;

		player.opts.cameraSlerp = 0.2;

		if (this.setupPlayerAttachedTo) {
			this.setupPlayerAttachedTo.mesh.visible = false;
		}
			
		this.setupPlayerAttachedTo = setup;
		this.setupPlayerAttachedTo.mesh.visible = true;

		setup.height = setup.height;

		$rootScope.$broadcast( "spherical360SetupService.playerAttached", this.setupPlayerAttachedTo );
	};
	
	this.detachPlayer = function() {
		player.$keyboardControlsDisabled = false;
		this.setupPlayerAttachedTo = null;
	};

	this.genSaves = function() {

		var saves = this.setups.reduce(( obj, setup ) => {

			obj[ setup.uuid ] = setup.toJSON();

			return obj;

		}, { });

		if (this.setupPlayerAttachedTo) {
			if (saves[ this.setupPlayerAttachedTo.uuid ]) {
				saves[ this.setupPlayerAttachedTo.uuid ].playerAttached = true;
			}
		}

		return JSON.parse( JSON.stringify( saves ));
	}

	this.loadSaves = function( saves ) {

		if (!saves || Object.keys( saves ).length == 0) return;

		var setupPlayerAttachedToUuid = null;

		for (var i in saves) {

			var setup = Spherical360Setup.fromJSON( saves[i] );

			if (saves[i].playerAttached) setupPlayerAttachedToUuid = saves[i].uuid;

			this.add( setup );
		}

		if (setupPlayerAttachedToUuid) {
			this.attachPlayer( setupPlayerAttachedToUuid );
		}
	};
}

Spherical360SetupService.getInstance = () => spherical360SetupService;

Spherical360SetupService.$inject = [ "$rootScope","$compile","$timeout","wallsHandlerService","userActionHistoryService" ];

Spherical360SetupService.prototype = Object.create( Group.prototype );


/**********************/


export class Spherical360Setup {

	/*
	uuid      = null;
	geometry  = null;
	material  = Spherical360Setup.generateMaterial();
	texture   = null;
	image_uid = null;

	_height = 0;
	_levelCorrection = 0;
	*/

	constructor( texture, options ) {

		this.uuid      = null;
		this.geometry  = null;
		this.material  = Spherical360Setup.generateMaterial();
		this.texture   = null;

		this.image_uid = null;
		this.image_url = null;

		this._height = 0;
		this._levelCorrection = 0;

		this.uuid = THREEMath.generateUUID( );

		options = angular.extend({
			height: 1
		}, options );

		var geo = {
			radius         : 100,
			widthSegments  : 64,
			heightSegments : 32,
			phiStart       : 0,
			phiLength      : Math.PI * 2,
			thetaStart     : 0,
			thetaLength    : Math.PI
		};

		for (var key in geo) {
			if (!angular.isUndefined( options[ key ])) {
				geo[ key ] = options[ key ];
			}
		}

		this.geometry = new SphereGeometry( geo.radius, geo.widthSegments, geo.heightSegments, geo.phiStart, geo.phiLength, geo.thetaStart, geo.thetaLength );
		this.geometry.scale( -1, 1, 1 );

		if (texture) {
			this.setTexture( texture );
		} else {
			
			let small_image_url = this.buildImageUrl( 'small' );

			if (small_image_url) {
				this.setTexture( small_image_url );
			} else {
				this.setTexture( new Texture( ));
			}
		}

		if (options.position) {
			if (Array.isArray( options.position )) {
				this.position.fromArray( options.position );
			} else if (options.position instanceof Vector3) {
				this.position.copy( options.position );
			} else {
				throw new Error( "Invalid argument" );
			}
		}

		if (options.rotation) {
			if (Array.isArray( options.rotation )) {
				this.rotation.fromArray( options.rotation );
			} else if (options.rotation instanceof Euler) {
				this.rotation.copy( options.rotation );
			} else {
				throw new Error( "Invalid argument" );
			}
		}

		if (options.name) {
			this.name = options.name;
		}

		if (options.image_uid) {
			this.image_uid = options.image_uid;
		} else if (options.image_url) {
			this.image_url = options.image_url;
		}

		if (options.height) {
			this.height = options.height;
		}

		if (options.levelCorrection) {
			this.levelCorrection = options.levelCorrection;
		}
	}

	setTexture( texture ) {

		if (texture instanceof Texture) {

			this.texture = texture;

		} else if (typeof texture == "string") {

			var url = texture, self = this;

			this.texture = /* new TextureLoader() */ getTextureLoader().load( url, function( texture ) {

				try {
					if (!(/^data:image\/[^;]+;base64,/).test( url.substr( 0, 25 ))) {

						// Muutetaan kuvan tekstuurin lähde data_uri'ksi jotta se voidaan vaivattovimmin tallentaa
						// texture.image.src = ArtestUserAssets.imageToBase64( texture.image );

						self.refreshMesh();
					}
				} catch (error) {
					console.error( error );
				}
			});
		}

		this.refreshMesh();
	}

	refreshMesh() {
		var parent;

		if (this.mesh && this.mesh.parent) {
			parent = this.mesh.parent;
			Group.prototype.remove.call( parent, this.mesh );
		}

		this.material.map = this.texture;
		this.material.needsUpdate = true;

		if (this.mesh) {

			var { rotation, position } = this;

			this.mesh = new Mesh( this.geometry, this.material );

			this.mesh.position.copy( position );
			this.mesh.rotation.copy( rotation );
		} else {
			this.mesh = new Mesh( this.geometry, this.material );
		}
			
		this.mesh.uuid = this.uuid;

		var self = this;

		if (parent) {
			Group.prototype.add.call( parent, this.mesh );
		}
	}

	get position() { return this.mesh.position; }
	set position( position ) {
		return this.mesh.position.copy( position );
	}

	get rotation() { return this.mesh.rotation; }
	set rotation( rotation ) {
		return this.mesh.rotation.copy( rotation );
	}

	get levelCorrection() { return this._levelCorrection; }
	set levelCorrection( levelCorrection ) {
		this._levelCorrection = levelCorrection;
		this.mesh.rotation.x = this._levelCorrection;
		this.mesh.rotation.z = this._levelCorrection;
	}

	get height() { return this._height; }
	set height( height ) {
		this._height = height;

		if (window.spherical360SetupService && window.spherical360SetupService.setupPlayerAttachedTo == this) {
			window.spherical360SetupService.attachedPlayerNeedsUpdate = true;
		}
	}

	buildImageUrl( size = 'large' ) {
		if (this.image_uid) {

			let url = "/i/" + this.image_uid;

			switch (size) {
				case 'small':
					url += "?size=64x64^";
					break;
				case 'large':
				default:
					url += "?size=1024x1024^";
					break;
			}

			return url;

		} else if (this.image_url) {
			return this.image_url;
		}

	}

	toJSON() {
		return {
			uuid            : this.uuid,
			name            : this.name,
			image_uid       : this.image_uid || undefined,
			image_url       : this.image_url || undefined,
			levelCorrection : this.levelCorrection,
			height          : this.height,
			position        : this.position.toArray(),
			rotation        : this.rotation.toArray(),

			heightSegments  : this.geometry.heightSegments,
			phiLength       : this.geometry.phiLength,
			phiStart        : this.geometry.phiStart,
			radius          : this.geometry.radius,
			thetaLength     : this.geometry.thetaLength,
			thetaStart      : this.geometry.thetaStart,
			widthSegments   : this.geometry.widthSegments,

			//texture         : this.texture.image.src // Jokin parempi keino?
		};
	}

	static fromJSON( json ) {

		/******
		 * Mikä olisi pätevämpi keino tallentamisen?
		 */
		if (!json.image_uid && angular.isString( json.texture )) {

			var match = json.texture.match( /^\/i\/(B2[A-F0-9]{14})/ );
			
			if (match) json.image_uid = match[1] || null;
			else json.image_url = json.texture;
		}
		/*****/

		var setup = new Spherical360Setup( json.texture, json );

		setup.uuid = setup.mesh.uuid = json.uuid;

		return setup;
	}

	static generateMaterial( material ) {
		return new MeshBasicMaterial( material );
	}
}
